import React from "react";
import HospitalLogin from "./HospitalLogin/HospitalLogin";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Map from './Map.js'
import PatientTracker from './PatientTracker.js'
import MovieList from './MovieList'
import DonationForm from './DonationForm'
import UserManualComponent from './UserManual'

function MainRoute() {
  return (
    <Router>
      <Switch>
        <Route path="/hospital-login" component={HospitalLogin} />
      <Route path="/" exact component={Map} />
    <Route path = "/p" component = {PatientTracker}/>
  <Route path = "/dashboard" component = {MovieList} />
<Route path = "/donationform" component = {DonationForm} />
<Route path = '/UserManual' componenet = {UserManualComponent}/>

    </Switch>
    </Router>
  );
}

export default MainRoute;
